var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSnow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 143,
    viewBox: "0 0 135 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.5 34.0981L91.0997 10.4043M67.5 34.0981L43.9003 10.4043M67.5 34.0981V3M67.5 34.0981V62.1495M67.5 108.902L91.0997 132.596M67.5 108.902L43.9003 132.596M67.5 108.902V140M67.5 108.902V80.8505M99.7623 52.7991L132 61.4716M99.7623 52.7991L108.4 20.4327M99.7623 52.7991L126.587 37.25M99.7623 52.7991L75.5656 66.8248M35.2377 90.2009L26.5997 122.567M35.2377 90.2009L3 81.5284M35.2377 90.2009L8.41298 105.75M35.2377 90.2009L59.4344 76.1752M99.7623 90.201L108.4 122.567M99.7623 90.201L132 81.5284M99.7623 90.201L126.587 105.75M99.7623 90.201L75.5656 76.1752M35.2377 52.7991L3 61.4716M35.2377 52.7991L26.5997 20.4327M35.2377 52.7991L8.41299 37.25M35.2377 52.7991L59.4344 66.8248M59.4344 66.8248L67.5 62.1495M59.4344 66.8248V76.1752M67.5 62.1495L75.5656 66.8248M75.5656 66.8248V76.1752M75.5656 76.1752L67.5 80.8505M67.5 80.8505L59.4344 76.1752",
    stroke: "#59C9FC",
    strokeWidth: 5,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnow);
export default __webpack_public_path__ + "static/media/snow.b740bbed1f0d9c13c37b6c12425a5d33.svg";
export { ForwardRef as ReactComponent };